import { MatterSubItemContextMenu } from "@/components/features/matter/context-menus/MatterSubItemContextMenu";
import { ContextMenuItem } from "@/components/ui";
import type { Matter } from "@/lib/types";
import { BriefcaseBusiness } from "lucide-react";
import type { ReactNode } from "react";

interface MatterLostWageContextMenuProps {
  canDelete: boolean;
  canUpdate: boolean;
  employed?: boolean | null;
  id: string;
  isDeleting: boolean;
  isUpdating: boolean;
  label: string;
  matter: Matter;
  onDelete: () => Promise<void>;
  onEdit: () => void;
  onEmployedChange: (employed: boolean) => Promise<void>;
  positionRate?: number | null;
  positionType?: string | null;
  trigger: ReactNode;
}

export const MatterLostWageContextMenu = ({
  canDelete,
  canUpdate,
  employed,
  id,
  isDeleting,
  isUpdating,
  label,
  matter,
  onDelete,
  onEdit,
  onEmployedChange,
  positionRate,
  positionType,
  trigger,
}: MatterLostWageContextMenuProps) => (
  <MatterSubItemContextMenu
    actions={
      canUpdate ? (
        <ContextMenuItem
          disabled={isUpdating}
          onSelect={() => {
            void onEmployedChange(employed === false);
          }}
        >
          <BriefcaseBusiness />
          {employed === false ? "Mark as employed" : "Mark as not employed"}
        </ContextMenuItem>
      ) : undefined
    }
    copyValue={[
      label,
      positionType ? `Type: ${positionType}` : undefined,
      positionRate != null ? `Rate: $${positionRate}` : undefined,
    ]
      .filter(Boolean)
      .join("\n")}
    createSignatureRequest
    delete={canDelete ? { disabled: isDeleting, onSelect: onDelete } : false}
    entityLabel={label}
    entityName="employment wage"
    matter={matter}
    onEdit={onEdit}
    subItem={{ id, type: "lost-wage" }}
    trigger={trigger}
  />
);
